<template>
  <AppTransitionFade duration="0.3">
    <div
      v-if="loading"
      class="absolute inset-0 bg-black/10 z-10 flex justify-center items-center"
    >
      <AppLoadingSpinner
        class="w-10 h-10"
        thickness="3"
      />
    </div>
  </AppTransitionFade>
</template>

<script setup lang="ts">
defineProps({
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>
